import { apiOptions, apiRequest } from "../../utils";
import { API_V3 } from "../../constants";

export const tradeService = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_V3}/trades`,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    return apiRequest(options);
  },

  create: async ({ request }) => {
    const options = await apiOptions({
      url: `${API_V3}/trades`,
      method: "post",
      data: request,
    });
    const toastMessageConfig = {
      success: {
        message: "Trade added successfully",
      },
    };
    return apiRequest(options, toastMessageConfig);
  },

  replace: async ({ id, request }) => {
    const options = await apiOptions({
      url: `${API_V3}/trades/${id}`,
      method: "put",
      data: request,
    });
    return apiRequest(options);
  },

  update: async ({ id, request }) => {
    const options = await apiOptions({
      url: `${API_V3}/trades/${id}`,
      method: "patch",
      data: request,
    });
    const toastMessageConfig = {
      success: {
        message: "Trade edited successfully",
      },
    };
    return apiRequest(options, toastMessageConfig);
  },

  delete: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_V3}/trades/${id}`,
      method: "delete",
    });
    const toastMessageConfig = {
      success: {
        message: "Trade deleted successfully",
      },
    };
    return apiRequest(options, toastMessageConfig);
  },
};
